export function getRandomValue() {
  return Math.floor(Math.random() * Math.floor(10000));
}
